<template>
    <div id="home-page">
        <!-- AD -->
        <!-- <div class="ad-wrap-1">
            <img src="https://via.placeholder.com/200x600/b33b3b" alt="">
        </div>
        <div class="ad-wrap-2">
            <img src="https://via.placeholder.com/200x600/b33b3b" alt="">
        </div> -->
        <div v-if="currentHomeTopAd" v-on:click="handleAdClick(currentHomeTopAd)" class="header-banner">
            <img :src="currentHomeTopAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentHomeTopAd" v-on:click="handleAdClick(currentHomeTopAd)" class="header-banner-mobile">
            <img :src="currentHomeTopAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <!-- AD END -->
        <div class="wine-month-wrap">
            <router-link :to="{ name: 'wine-info-page', params: {wineID: wineOfTheMonth.id} }">
            <div class="wine-month-top-bar">
                <h1>Vín mánaðarins</h1>
            </div>
            <div class="wine-month">
                <div class="wine-month-image-wrap">
                    <div class="wine-month-image">
                        <img :src="wineOfTheMonth.image | optimizeWine" alt="">
                    </div>
                </div>
                <div class="wine-month-text">
                    <div class="wine-month-title">
                        <h1>{{ wineOfTheMonth.name }}</h1>
                    </div>
                    <div class="wine-month-button">
                        <input type="button" value="Skoða">
                    </div>
                </div>
            </div>
            </router-link>
        </div>
        <!-- AD -->
        <!-- <div class="ad-wrap-mobile-1">
            <img src="https://via.placeholder.com/690x200/b33b3b" alt="">
        </div>  -->
        <!-- AD END -->
        <div class="newest-blog-wrap">
            <router-link :to="{ name: 'blog-post', params: {postID: mostRecentBlog.id} }">
            <div class="newest-blog-image-wrap">
                <div class="newest-blog-image">
                    <img :src="mostRecentBlog.image | optimizeBlog" alt="">
                </div>
            </div>
            <div class="newest-blog-content">
                
                <div class="newest-blog-title">
                    <p>{{ mostRecentBlog.title }}</p>
                </div>
                <div v-html="removeImgElement(mostRecentBlog.body)" id="newest-blog-body" class="newest-blog-body">

                </div>
                
                    <div class="newest-blog-button button">
                        <input type="button" value="Skoða">
                    </div>
                
                <div class="newest-blog-footer">
                    <!-- <div class="newest-blog-footer-date">
                        <p>{{ displayDate(mostRecentBlog.publishdate) }}</p>
                    </div> -->
                </div>
            </div>
            </router-link>
        </div>
        <!-- AD -->
        <!-- <div class="ad-wrap-3">
            <img src="https://via.placeholder.com/720x100/b33b3b" alt="">
        </div>
        <div class="ad-wrap-mobile-2">
            <img src="https://via.placeholder.com/690x200/b33b3b" alt="">
        </div> -->
        <!-- AD END -->
        <div class="view-catalog-wrap">
            <div class="filter"></div>
            <div class="view-catalog-text">
                <p>Skoða öll vín</p>
                <router-link to="/vin"><input type="button" value="Skoða"></router-link>
            </div>
        </div>

        <div class="view-food-wrap">
            <div class="filter"></div>
            <div class="view-food-text">
                <p>Finndu rétta vínið með matnum</p>
                <router-link to="/vin-med-mat"><input type="button" value="Skoða"></router-link>
            </div>
        </div>
        <!-- AD -->
        <!-- <div class="ad-wrap-mobile-3">
            <img src="https://via.placeholder.com/690x200/b33b3b" alt="">
        </div> -->
        <div v-if="currentHomeBottomAd" v-on:click="handleAdClick(currentHomeBottomAd)" class="footer-banner">
            <img :src="currentHomeBottomAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentHomeBottomAd" v-on:click="handleAdClick(currentHomeBottomAd)" class="footer-banner-mobile">
            <img :src="currentHomeBottomAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <!-- AD END -->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
const fb = require('../firebaseConfig.js')

export default {
    name: 'home',
    data() {
        return {
            wineOfTheMonth: {
                name: "",
                image: "",
                url: "",
                id: ""
            },
            mostRecentBlog: {
                title: "",
                body: "",
                image: "",
                publishdate: "",
                url: "",
                id: ""
            }
        }
    },
    methods: {
        getWineOfTheMonth() {
            var currentMonth = new Date().getMonth()
            var currentYear = new Date().getFullYear()
            this.months.forEach(element => {
                if (currentMonth+1 == element.month && currentYear == element.year) {
                    this.wines.forEach(wine => {
                        if (wine.id == element.wineid) {
                            this.wineOfTheMonth.name = wine.name
                            this.wineOfTheMonth.image = wine.image
                            this.wineOfTheMonth.id = wine.id
                        }
                    });
                }
            });
        },
        getMostRecentBlog() {
            var now = new Date()
            var copyBlogs = this.blogs.slice()
            /* var maxChars = 280 */
            var maxChars = 160
            copyBlogs.sort(function(a,b){return Date.parse(b.datepublished) - Date.parse(a.datepublished)})
            for (let index = 0; index < copyBlogs.length; index++) {
                if (Date.parse(copyBlogs[index].datepublished) < now) {
                    this.mostRecentBlog.title = copyBlogs[index].title
                    var blogBodyShort = ""
                    var dotIndexesArray = []
                    if (copyBlogs[index].body.length > maxChars) {
                        // Make an array of indexes of all dots '.' in the body text to find where to cut the short body text off
                        for (var i=0; i < copyBlogs[index].body.length; i++) {
                            if (copyBlogs[index].body[i] == '.') {
                                dotIndexesArray.push(i)
                            }
                        }
                        // Go through every sentence and add them together while the short body is still below max characters allowed
                        for (let i = 0; i < dotIndexesArray.length; i++) {
                            if (dotIndexesArray[i] <= maxChars) {
                                blogBodyShort = copyBlogs[index].body.slice(0, dotIndexesArray[i]+1)
                            }
                        }

                        this.mostRecentBlog.body = blogBodyShort
                    } else {
                        this.mostRecentBlog.body = copyBlogs[index].body
                    }
                    
                    this.mostRecentBlog.image = copyBlogs[index].image
                    this.mostRecentBlog.publishdate = copyBlogs[index].datepublished
                    this.mostRecentBlog.id = copyBlogs[index].id
                    return
                }
            }
        },
        removeImgElement(string) {
            var newBody = string.replace(/<img[^>]*>/g,"");
            return newBody
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY')
            } else {
                return "Please select a date"
            }
            
        },
        handleAdClick(ad) {
            fb.db.collection("ads").doc(ad.id).update({
                clicks: ad.clicks + 1,
            })
            window.open(ad.url)
        }
    },
    watch: {
        wines: function() {
            this.getWineOfTheMonth()
        },
        months: function () {
            this.getWineOfTheMonth()
        },
        blogs: function() {
            this.getMostRecentBlog()
        }
    },
    created: function() {
        this.getWineOfTheMonth()
        this.getMostRecentBlog()
    },
    mounted: function() {
        
    },
    computed: {
        ...mapState(['months', 'wines', 'blogs', 'currentHomeTopAd', 'currentHomeBottomAd'])
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_300/')
            return newUrl
        },
        optimizeBlog: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_1050/')
            return newUrl
        },
        optimizeBanner: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto/')
            return newUrl
        }
    }
}
</script>

<style>
@media only screen and (max-width: 768px) {
    .wine-month-wrap {
        position: relative;
        width: 100%;
        height:520px;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .wine-month {
        height:100%;
    }
    .wine-month-top-bar {
        position: relative;
        width:100%;
        height:50px;
        line-height: 50px;
    }
    .wine-month-image-wrap {
        height: 300px;
        width:100%;
        margin-top: 10px;
    }
    .wine-month-image {
        height:100%;
        width:100%;
        margin: auto;
    }
    .wine-month-image img {
        max-width:100%;
        max-height:100%;
    }
    .wine-month-text {
        width: 100%;
        height: 280px;
        margin-top: 10px;
    }
    .wine-month-title {
        height:85px;
        font-size: 18px;
        font-size: min(4vw, 18px);
    }
    .wine-month-title h1 {
        padding:0;
        margin:0;
    }
    .wine-month-description {
        margin: 0 10px;
        height: 190px;
        max-height: 180px;
        overflow: hidden;
    }
    .wine-month-description p {
        font-size: 18px;
        width:100%;
        text-align: justify;
    }
    .wine-month-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        bottom:0;
        margin-top: 15px;
    }
    .wine-month-button input:focus {
        outline: none;
    }

    .newest-blog-wrap {
        /* height: 430px; */
        width:100%;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
        background-color: white;
    }
    .newest-blog-image {
        width:100%;
        overflow: hidden;
        margin: 0 auto;
        position: relative;
        height: 209px;
    }
    .newest-blog-image img {
        max-width: 100%;
        min-height: 150px;
        top: 0;
        bottom: 0;
    }
    .newest-blog-content {
        position: relative;
        padding: 5px 15px;
    }
    .newest-blog-title {
        font-size: 26px;
        /* max-height: 50px; */
        text-align: left;
        overflow: hidden;
    }
    .newest-blog-title p {
        margin: 0;
        font-weight: bold;
    }
    .newest-blog-body {
        width: 100%;
        /* height: 120px; */
        text-align: justify;
        overflow: hidden;
    }
    .newest-blog-body p {
        font-size: 18px;
        margin:0;
    }
    .newest-blog-button {
        position: relative;
        width: 100%;
        margin-top: 10px;
        padding-bottom: 10px;
    }
    .newest-blog-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
    .newest-blog-button input:focus {
        outline: none;
    }
    .newest-blog-footer {
        position: absolute;
        width:100%;
        float:right;
    }
    .newest-blog-footer-date p {
        margin:0;
        color: #B33B3B;
        text-align: right;
        margin-right: 20px;
        margin-top: 16px;
    }

    .view-catalog-wrap {
        position: relative;
        width:100%;
        height: 300px;
        margin-top: 30px;
        background-image: url("../assets/temp_img.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .view-catalog-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-catalog-text p {
        color: white;
        font-size: 26px;
    }
    .view-catalog-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }

    .view-food-wrap {
        position: relative;
        width:100%;
        height: 300px;
        margin-top: 30px;
        background-color: black;
        background-image: url("../assets/temp_food.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .filter {
        position: absolute;
        background-color: black;
        height:100%;
        width:100%;
        opacity:0.6;
    }
    .view-food-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-food-text p {
        color: white;
        font-size: 26px;
    }
    .view-food-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
}

@media only screen and (min-width: 769px) {
    #home-page {
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width:100%;
    }
    .wine-month-wrap {
        position: relative;
        float:left;
        width: 33%;
        height:520px;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .wine-month {
        height:100%;
    }
    .wine-month-top-bar {
        position: relative;
        width:100%;
        height:50px;
        line-height: 50px;
    }
    .wine-month-top-bar h1 {
        padding:0;
        margin:0;
    }
    .wine-month-image-wrap {
        height: 300px;
        width:100%;
        margin-top: 10px;
    }
    .wine-month-image {
        height:100%;
        width:100%;
        margin: auto;
    }
    .wine-month-image img {
        max-width:100%;
        max-height:100%;
    }
    .wine-month-text {
        width: 100%;
        height: 280px;
        margin-top: 10px;
    }
    .wine-month-title {
        font-size: 18px;
        font-size: 1.2vw;
    }
    .wine-month-title h1 {
        padding:0;
        margin:0;
    }
    .wine-month-description {
        margin: 0 10px;
        height: 190px;
        max-height: 180px;
        overflow: hidden;
    }
    .wine-month-description p {
        font-size: 18px;
        width:100%;
        text-align: justify;
    }
    .wine-month-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        bottom:0;
        margin-top: 15px;
    }
    .wine-month-button input:focus {
        outline: none;
    }

    .newest-blog-wrap {
        float:right;
        height: 520px;
        width:65%;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
        background-color: white;
    }
    .newest-blog-image-wrap {
        
    }
    .newest-blog-image {
        width:100%;
        height: 300px;
        overflow:hidden;
    }
    .newest-blog-image img {
        max-width: 100%;
        min-height: 300px;
    }
    .newest-blog-content {
        position: relative;
        padding: 15px 25px;
    }
    .newest-blog-title {
        font-size: 26px;
        max-height: 50px;
        overflow: hidden;
        text-align: left;
    }
    .newest-blog-title p {
        font-weight: bold;
        margin: 0;
    }
    .newest-blog-body {
        width: 100%;
        height: 100px;
        margin-top: 10px;
        overflow: hidden;
        text-align: left;
    }
    .newest-blog-body p {
        font-size: 20px;
        margin: 0;
    }
    .newest-blog-button {
        position: relative;
        width:100%;
        margin-top: 5px;
    }
    .newest-blog-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
    .newest-blog-button input:focus {
        outline: none;
    }
    .newest-blog-footer {
        position: absolute;
        width:100%;
        float:right;
    }
    .newest-blog-footer-date p {
        margin:0;
        color: #B33B3B;
        text-align: right;
        margin-right: 20px;
        margin-top: 16px;
    }


    .view-catalog-wrap {
        position: relative;
        width:49%;
        height: 300px;
        margin-top: 20px;
        background-image: url("../assets/temp_img.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .view-catalog-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-catalog-text p {
        color: white;
        font-size: 26px;
    }
    .view-catalog-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }

    .view-food-wrap {
        position: relative;
        width:49%;
        height: 300px;
        margin-top: 20px;
        background-color: black;
        background-image: url("../assets/temp_food.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .filter {
        position: absolute;
        background-color: black;
        height:100%;
        width:100%;
        opacity:0.6;
    }
    .view-food-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-food-text p {
        color: white;
        font-size: 26px;
    }
    .view-food-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
}

@media only screen and (min-width: 1200px) {
    #home-page {
        position: relative;
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width:100%;
    }
    .wine-month-wrap {
        position: relative;
        float:left;
        width: 33%;
        height:520px;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .wine-month {
        height:100%;
    }
    .wine-month-top-bar {
        position: relative;
        width:100%;
        height:50px;
        line-height: 50px;
    }
    .wine-month-top-bar h1 {
        padding:0;
        margin:0;
    }
    .wine-month-image-wrap {
        height: 300px;
        width:100%;
        margin-top: 10px;
    }
    .wine-month-image {
        height:100%;
        width:100%;
        margin: auto;
    }
    .wine-month-image img {
        max-width:100%;
        max-height:100%;
    }
    .wine-month-text {
        width: 100%;
        height: 100px;
        margin-top: 10px;
    }
    .wine-month-title {
        height:85px;
        font-size: 18px;
        font-size: 1vw;
    }
    .wine-month-title h1 {
        padding:0;
        margin:0;
    }
    .wine-month-description {
        margin: 0 10px;
        height: 190px;
        max-height: 180px;
        overflow: hidden;
    }
    .wine-month-description p {
        font-size: 18px;
        width:100%;
        text-align: justify;
    }
    .wine-month-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        bottom:0;
        margin-top: 15px;
    }
    .wine-month-button input:focus {
        outline: none;
    }

    .newest-blog-wrap {
        float:right;
        height: 520px;
        width:65%;
        margin-top: 20px;
        /* box-shadow: 0 1px 6px #8f8c8b; */
        background-color: white;
    }
    .newest-blog-image-wrap {
        
    }
    .newest-blog-image {
        width:100%;
        height: 300px;
        overflow:hidden;
    }
    .newest-blog-image img {
        width: 100%;
        min-height: 300px;
    }
    .newest-blog-content {
        position: relative;
        padding: 15px 25px;
    }
    .newest-blog-title {
        font-size: 26px;
        text-align: left;
    }
    .newest-blog-title p {
        font-weight: bold;
        margin:0;
    }
    .newest-blog-body {
        width:100%;
        height: 100px;
        margin-top: 10px;
        overflow: hidden;
        text-align: left;
    }
    .newest-blog-body p {
        font-size: 20px;
        margin:0;
    }
    .newest-blog-button {
        position: relative;
        width:100%;
        margin-top: 5px;
    }
    .newest-blog-button input {
        margin:0 auto;
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
    .newest-blog-button input:focus {
        outline: none;
    }
    .newest-blog-footer {
        position: absolute;
        width:100%;
        float:right;
    }
    .newest-blog-footer-date p {
        margin:0;
        color: #B33B3B;
        text-align: right;
        margin-right: 20px;
        margin-top: 16px;
    }


    .view-catalog-wrap {
        position: relative;
        width:49%;
        height: 300px;
        margin-top: 20px;
        background-image: url("../assets/temp_img.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .view-catalog-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-catalog-text p {
        color: white;
        font-size: 26px;
    }
    .view-catalog-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }

    .view-food-wrap {
        position: relative;
        width:49%;
        height: 300px;
        margin-top: 20px;
        background-color: black;
        background-image: url("../assets/temp_food.png");
        /* box-shadow: 0 1px 6px #8f8c8b; */
    }
    .filter {
        position: absolute;
        background-color: black;
        height:100%;
        width:100%;
        opacity:0.6;
    }
    .view-food-text {
        position:absolute;
        width:100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .view-food-text p {
        color: white;
        font-size: 26px;
    }
    .view-food-text input {
        border: none;
        border-radius: 10px;
        padding:10px;
        font-size: 16px;
        width:100px;
        cursor:pointer;
        background-color: #B33B3B;
        color: white;
    }
    /* AD */
    .ad-wrap-1 {
        position: absolute;
        margin-left: -300px;
        margin-top: 30px;
    }
    .ad-wrap-2 {
        position: absolute;
        right: 0;
        margin-right: -300px;
        margin-top: 30px;
    }
    .ad-wrap-3 {
        margin: 0 auto;
        margin-top: 20px;
    }
    /* AD END */
}

.wine-month-wrap {
    background-color: white;
}
.wine-month-top-bar {
    background-color: #B33B3B;
    color:white;
}
.wine-month-text {
    color: #B33B3B;
}
.wine-month-description {
    color:#2c3e50;
}
.wine-month-button input {
    background-color: #B33B3B;
    color: white;
}
.wine-month-title {
    color: #2c3e50;
    line-height: 40px;
}
/* AD */    
@media only screen and (max-width: 769px) {
    .header-banner, .footer-banner {
        display: none;
    }
}
@media only screen and (min-width: 769px) and (max-width: 1199px) {
    .header-banner-mobile, .footer-banner-mobile {
        display: none;
    }
}
@media only screen and (min-width: 1200px) {
    .header-banner-mobile, .footer-banner-mobile {
        display: none;
    }
}

.header-banner {
    margin-top: 20px;
    cursor: pointer;
}
.header-banner img {
    width: 100%;
}
.header-banner-mobile {
    margin-top: 20px;
    cursor: pointer;
}
.header-banner-mobile img {
    width: 100%;
}
.footer-banner {
    margin-top: 20px;
    cursor: pointer;
}
.footer-banner img {
    width: 100%;
}
.footer-banner-mobile {
    margin-top: 20px;
    cursor: pointer;
}
.footer-banner-mobile img {
    width: 100%;
}
/* AD END */
</style>